import React from 'react';
import { Entity } from '../../../../../../../../@Api/Model/Implementation/Entity';
import useTypes from '../../../../../Type/Api/useTypes';
import useAggregateResult from '../../../../../Selection/Hooks/useAggregateResult';
import { Aggregate } from '../../../../../../DataObject/Model/Aggregate';
import { observer } from 'mobx-react';
import getDurationLabel from '../../../../../../../../@Util/Date/getDurationLabel';

export interface TimeRegistrationDurationProps
{
    entity: Entity
    milestone?: Entity
    isEmployee?: boolean
}

const TimeRegistrationDuration: React.FC<TimeRegistrationDurationProps> =
    ({
         entity,
         milestone,
         isEmployee
     }) =>
        {
            const types = useTypes();

            const timeRegistrationDurationInHours =
                useAggregateResult(
                    types.TimeRegistration.Type,
                    (builder, rootPath) =>
                        builder
                            .if(
                                () =>
                                    isEmployee === undefined,
                                sb =>
                                    sb.where(
                                        cb =>
                                            cb.relatedToEntity(
                                                rootPath
                                                    .joinTo(
                                                        types.Activity.RelationshipDefinition.TimeRegistrations,
                                                        true
                                                    ),
                                                entity
                                            )
                                    )
                            )
                            .if(
                                () =>
                                    milestone !== undefined,
                                sb =>
                                    sb.where(
                                        cb =>
                                            cb.relatedToEntity(
                                                rootPath
                                                    .joinTo(
                                                        types.Milestone.RelationshipDefinition.TimeRegistrations,
                                                        true
                                                    ),
                                                milestone
                                            )
                                    )
                            )
                            .if(
                                () =>
                                    isEmployee !== undefined && isEmployee,
                                sb =>
                                    sb.where(
                                        cb =>
                                            cb.relatedToEntity(
                                                rootPath
                                                    .joinTo(
                                                        types.Relationship.Person.Contact.Employee.RelationshipDefinition.TimeRegistrations,
                                                        true
                                                    ),
                                                entity
                                            )
                                    )
                            )
                            .if(
                                () =>
                                    isEmployee !== undefined && !isEmployee,
                                sb =>
                                    sb.where(
                                        cb =>
                                            cb.relatedToEntity(
                                                rootPath
                                                    .joinTo(
                                                        types.Relationship.RelationshipDefinition.TimeRegistrations,
                                                        true
                                                    ),
                                                entity
                                            )
                                    )
                            )
                            .aggregateOn(
                                rootPath.field(types.TimeRegistration.Field.DurationInHours),
                                undefined,
                                Aggregate.Sum
                            ),
                    [
                        types,
                        entity,
                        milestone
                    ]
                );

            if(timeRegistrationDurationInHours && timeRegistrationDurationInHours.aggregates[0].value > 0)
            {
                return <>
                    {
                        getDurationLabel(timeRegistrationDurationInHours.aggregates[0].value * 3600 * 1000)
                    }
                </>
            }
            else
            {
                return null
            }
        }

export default observer(TimeRegistrationDuration)
